import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
const AppBarAppMobileTeleporter = (props)=>{
    const { children  } = props;
    const [element, setElement] = useState(null);
    useEffect(()=>{
        const appBar = document.getElementById("AppBarMobile");
        if (appBar) setElement(appBar);
        return ()=>{
            setElement(null);
        };
    }, []);
    return element ? /*#__PURE__*/ createPortal(children, element) : null;
};
export default AppBarAppMobileTeleporter;
